module.exports = __webpack_public_path__ + "static/media/oberflex-merisierdamerique-1200x2490.eb9c5ad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-merisierdamerique-1200x2490.jpg
// module id = 1032
// module chunks = 37